import { IOpenMarketProduct } from '../../../interfaces/OpenMarketProduct.interfaces';
import { customAxios } from '../../common/customAxios';

interface IGetNextOpenMarketProductsParams {
  productId: string;
}

export const getNextOpenMarketProducts = ({
  productId,
}: IGetNextOpenMarketProductsParams): Promise<IOpenMarketProduct[]> => {
  return customAxios.get(`/user-sell-tractors/${productId}/next`);
};
